// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */

.app-header {
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid #e5e7eb;
  width: auto;
  /* ❌ NOT sticky */
  position: relative;
}

/* FULL-WIDTH header so logo can sit at extreme left */
.header-inner {
  padding: 0px 20px;       /* ⬅️ reduced height (~70%) */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo flush left + 20% larger */
.logo {
  flex-shrink: 0;
}

.logo img {
  height: 44px;            /* was 36px → ~20% increase */
}

/* Navigation pushed to right */
.nav {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Neutral app-wide typography */
.nav-link {
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  color: #334155;
  padding: 6px 10px;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}

.nav-link:hover {
  background: #f1f5f9;
  color: #0f172a;
}

/* User dropdown */
.user-menu {
  position: relative;
}

.user-button {
  font: inherit;
  background: #2563eb;
  color: #ffffff;
  border: none;
  padding: 6px 12px;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
}

.user-dropdown {
  position: absolute;
  right: 0;
  top: 42px;
  width: 260px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.12);
  padding: 14px;
  z-index: 100;
}

.user-dropdown p {
  margin: 6px 0;
  font-size: 14px;
  color: #334155;
}

.logout-button {
  margin-top: 12px;
  width: 100%;
  padding: 9px;
  font: inherit;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.logout-button:hover {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
}

.request-credits-button {
  margin-top: 12px;
  width: 100%;
  padding: 9px;
  font: inherit;
  background: linear-gradient(135deg, #3b82f6, #2563eb); /* blue gradient */
  color: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.request-credits-button:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
}

.request-credits-button:active {
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./src/css/Header.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,iBAAiB,QAAQ,6BAA6B;EACtD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA;EACE,YAAY,aAAa,6BAA6B;AACxD;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qDAAqD,EAAE,kBAAkB;EACzE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Header.css */\n\n.app-header {\n  background: rgba(255, 255, 255, 0.9);\n  border-bottom: 1px solid #e5e7eb;\n  width: auto;\n  /* ❌ NOT sticky */\n  position: relative;\n}\n\n/* FULL-WIDTH header so logo can sit at extreme left */\n.header-inner {\n  padding: 0px 20px;       /* ⬅️ reduced height (~70%) */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Logo flush left + 20% larger */\n.logo {\n  flex-shrink: 0;\n}\n\n.logo img {\n  height: 44px;            /* was 36px → ~20% increase */\n}\n\n/* Navigation pushed to right */\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Neutral app-wide typography */\n.nav-link {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  color: #334155;\n  padding: 6px 10px;\n  border-radius: 8px;\n  text-decoration: none;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.nav-link:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n/* User dropdown */\n.user-menu {\n  position: relative;\n}\n\n.user-button {\n  font: inherit;\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 999px;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);\n}\n\n.user-dropdown {\n  position: absolute;\n  right: 0;\n  top: 42px;\n  width: 260px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.12);\n  padding: 14px;\n  z-index: 100;\n}\n\n.user-dropdown p {\n  margin: 6px 0;\n  font-size: 14px;\n  color: #334155;\n}\n\n.logout-button {\n  margin-top: 12px;\n  width: 100%;\n  padding: 9px;\n  font: inherit;\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.logout-button:hover {\n  background: linear-gradient(135deg, #dc2626, #b91c1c);\n}\n\n.request-credits-button {\n  margin-top: 12px;\n  width: 100%;\n  padding: 9px;\n  font: inherit;\n  background: linear-gradient(135deg, #3b82f6, #2563eb); /* blue gradient */\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.request-credits-button:hover {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n}\n\n.request-credits-button:active {\n  transform: scale(0.98);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
